<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 16px;padding: 10px;">
              <span class="login-title">
                <img :src="igreja.logoUrl" width="230px">
              </span>
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 lg12>
                      <p class="catalogo-titulo" style="margin-bottom: 0px; text-align: center"><b>CATÁLOGO DE PROFISSIONAIS DA LIBERDADE</b></p>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Selecione o serviço:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-data-iterator
                        :items="iterador.conteudo"
                        :items-per-page.sync="iterador.itensPorPagina"
                        hide-default-footer
                        :loading="iterador.carregamento"
                      >
                        <template v-slot:header>
                          <v-autocomplete outlined dense :disabled="iterador.servicos.length == 0" v-model="servicoSelecionado" :items="iterador.servicos" hide-details item-text="nome" item-value="id" color="#00695C" label="SERVIÇOS" @input="searchInput = null" :search-input.sync="searchInput" @change="carregaProfissionais"></v-autocomplete>
                        </template>
                        <template v-slot:no-data>
                          <v-alert v-if="!servicoSelecionado" class="mt-5 mb-0" type="info" dense text>Selecione um serviço acima para visualizar o catálogo</v-alert>
                          <v-alert v-if="servicoSelecionado && iterador.conteudo.length == 0" class="mt-5 mb-0" type="info" dense text>Nenhum profissional localizado para o serviço selecionado</v-alert>
                        </template>
                        <template v-slot:loading>
                          <v-progress-linear class="mt-5 mb-0" indeterminate color="primary"></v-progress-linear>
                          <p class="mt-2 mb-0" style="text-align: center">Carregando itens...</p>
                        </template>
                        <template v-slot:default="props">
                          <v-row>
                            <v-col v-for="item in props.items" :key="item.name" cols="12" xs="12" sm="12" md="4" lg="4">
                              <v-card outlined class="card-profissional">
                                <v-list dense>
                                  <v-card-title>{{ item.nome.split(' ').slice(0, 2).join(' ') }}</v-card-title>
                                  <v-list-item style="text-align: center">
                                    <v-list-item-content style="padding: 0px">Serviços que atua:</v-list-item-content>
                                  </v-list-item>
                                  <v-list-item v-for="(profissao, index) in item.servicos" :key="index">
                                    <li>{{ profissao }}</li>
                                  </v-list-item>
                                  <v-list-item style="text-align: center; height: 50px">
                                    <v-list-item-content style="padding: 0px">{{ item.telefone }}</v-list-item-content>
                                    <v-btn icon :href="'tel:' + item.telefone.replace(/\D/g, '')" target="_blank" @click="salvaClique('TELEFONE', item.id)">
                                      <v-icon color="#00695C">mdi-phone</v-icon>
                                    </v-btn>
                                    <v-btn icon :href="'https://wa.me/55' + item.telefone.replace(/\D/g, '')" target="_blank" @click="salvaClique('WHATSAPP', item.id)">
                                      <v-icon color="#25D366">mdi-whatsapp</v-icon>
                                    </v-btn>
                                  </v-list-item>
                                </v-list>
                              </v-card>
                            </v-col>
                          </v-row>
                        </template>
                      </v-data-iterator>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <br>
        <div class="login-title">
          <a href="https://www.intelitetecnologia.com.br/" target="_blank">
            <img src="../../assets/logoTemplusIntelite.png" width="300px">
          </a>
        </div>
        <!-- FIM CATÁLOGO -->
      </v-container>
    </div>
    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </div>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  // import CpfValidate from '../../componentes/validators/rules/cpf'
  import { baseApiUrl } from '@/global'
  import Snackbar from '../../componentes/snackbar.vue'
  import { mapState } from 'vuex'
  // import moment from 'moment'
  import axios from 'axios'
  export default {
    components: { Snackbar, Loading, },
    name: 'Auth',
    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
    }),
    data: function () {
      return {
        idIgreja: '6390de5538a3bc18300a2022',
        iterador: {
          carregamento: false,
          conteudo: [],
          itensPorPagina: -1,
          servicos: [],
        },
        servicoSelecionado: '',
        searchInput: null,
        isLoading: false,
        fullPage: true,
        igreja: {},
      }
    },
    
    mounted: function () {
      this.carregaDados()
    },
    
    watch: {
      dialogoNaoCadastrado(val) {
        if (val == false) {
          window.location.reload()
        }
      }
    },

    methods: {
      async carregaDados() {
        this.isLoading = true
        try {
          const response = await axios.post(baseApiUrl + 'Igrejas/infoPublica', null, { params: { igrejaId: this.idIgreja } })
          if (response.data) {
            this.igreja = response.data
            this.carregaProfissoes()
            // this.carregaCelulas()
          }
        } catch (error) {
          this.$refs.chamaSnackbar.snack('#FF5252', 'Erro ao carregar dados da igreja.', 'ERRO')
        } finally {
          this.isLoading = false
        }
      },

      async carregaCelulas() {
        await axios.post(baseApiUrl + 'Celulas/listarPublicas', null, { params: { igrejaId: this.idIgreja } })
        .then(response => {
          if (response.data) {
            this.celulas = response.data
          }
        })
      },

      async carregaProfissoes() {
        await axios.post(baseApiUrl + 'ServicoProfissionals/listarPublicos', {
          igrejaId: this.igreja.id
        })
        .then(response => {
          if (response.data.length > 0) {
            this.iterador.servicos = response.data
          }
        })
      },

      async carregaProfissionais() {
        this.iterador.carregamento = true
        this.iterador.conteudo = []
        await axios.post(baseApiUrl + 'Profissionais/profissionaisComServicos', {"igrejaId": this.igreja.id, "servicoId": this.servicoSelecionado})
        .then(response => {
          if (response.data.length > 0) {
            this.iterador.conteudo = response.data
          }
          this.iterador.carregamento = false
        })
      },

      async salvaClique(tipo, id) {
        await axios.post(baseApiUrl + 'Interacoes/registrarPublica', { "tipo": tipo, "profissionalId": id, "igrejaId": this.igreja.id })
      },
    }
  }
</script>

<style scoped>
  /* LOGIN */

  .limiter {
    width: 100%;
    margin: 0 auto;
  }

  .container-login {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 15px;
    background: linear-gradient(135deg, #5BC1A3 0%, #01B094 52%, #00695C 100%);
    background-repeat: no-repeat;
    position: relative;
    z-index: 1;
  }

  .texto {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  .login {
    min-width: 80%;
    border-radius: 15px;
    background-color: #fff;
    opacity: 0.9;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .login-title {
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: center
  }

  .catalogo-titulo {
    font-family: 'Fraunces', serif;
    color: #00253E;
    font-size: 20px;
  }

  .card-profissional {
    border-radius: 16px !important;
    box-shadow: 0 4px 16px rgba(0, 37, 62, 0.08) !important;
  }
</style>
